import React from 'react'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'

import {
  RiUser3Line,
  RiSettings3Line,
  RiDashboard2Line,
  RiCalendarEventLine,
  // RiContactsLine,
  // RiShieldUserLine,
  // RiListUnordered,
  // RiForbidLine,
  // RiForbid2Line,
  RiBriefcaseLine,
  RiChat1Line,
  RiHeart3Line,
  // RiPlayListLine,
  RiGamepadLine,
  RiShieldKeyholeLine,
  // RiBellLine,
  RiVideoAddFill,
  RiHistoryLine,
  RiUserUnfollowLine ,
} from 'react-icons/ri'

const ICON_SIZE = 22

const SidebarMenuMain = () => {
  return (
    <>
      {/* MAIN */}
      <div className='menu-item'>
        <div className='menu-content pt-2 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Menu</span>
        </div>
      </div>

      <SidebarMenuItem

  to='/dashboard'

        icon={<RiDashboard2Line size={ICON_SIZE} />}
        title='Dashboard'
      />

      <SidebarMenuItemWithSub
        to='#'
        title='User Management'
        icon={<RiUser3Line size={ICON_SIZE} />}
      >
        <SidebarMenuItem to='/users' title='User List' hasBullet={true} />
        <SidebarMenuItem to='/directory' title='Directory List' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to='#'
        title='Event Management'
        icon={<RiCalendarEventLine size={ICON_SIZE} />}
      >
        <SidebarMenuItem to='/event-categories' title='Event Categories' hasBullet={true} />
        <SidebarMenuItem to='/events' title='Event List' hasBullet={true} />
      </SidebarMenuItemWithSub>

      {/* <SidebarMenuItem to='/roles' icon={<RiShieldUserLine size={ICON_SIZE} />} title='Roles' /> */}
      
      <SidebarMenuItemWithSub to='#' title='Chat' icon={<RiChat1Line size={ICON_SIZE} />}>
        <SidebarMenuItem to='/block-users' title='Block Users' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItem to='/interests' icon={<RiHeart3Line size={ICON_SIZE} />} title='Interests' />
      <SidebarMenuItemWithSub
        to='/jobs'
        icon={<RiBriefcaseLine size={ICON_SIZE} />}
        title='Jobs'
      >
        <SidebarMenuItem to='/jobs' title='Job List' hasBullet={true} />
        <SidebarMenuItem to='/skills' title='Skills' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItem
        to='/game'
        icon={<RiGamepadLine size={ICON_SIZE} />}
        title='Games'
      />
        <SidebarMenuItemWithSub
        to='/reels'
        icon={<RiVideoAddFill size={ICON_SIZE} />}
        title='Reels'
      >
        <SidebarMenuItem to='/reports' title='Reports' hasBullet={true} />
        </SidebarMenuItemWithSub>
     {/* <SidebarMenuItem
        to='/permissions'
        icon={<RiShieldKeyholeLine size={ICON_SIZE} />}
        title='Permissions'
      /> */}
      <SidebarMenuItemWithSub to='#' title='Access' icon={<RiShieldKeyholeLine size={ICON_SIZE} />}>
        {/* <SidebarMenuItem to='/roles' title='Roles' hasBullet={true} /> */}
        <SidebarMenuItem to='/permissions' title='Permissions'  hasBullet={true} />
        
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub to='#' title='Settings' icon={<RiSettings3Line size={ICON_SIZE} />}>
        <SidebarMenuItem to='/notifications' title='Notifications' hasBullet={true} />
      </SidebarMenuItemWithSub>
<SidebarMenuItem
        to='/activity'
        icon={<RiHistoryLine size={ICON_SIZE} />}
        title='Activity'
      />
      <SidebarMenuItem
        to='/Deleted-Users'
        icon={<RiUserUnfollowLine  size={ICON_SIZE} />}
        title='Deleted Users'
      />
     
    </>
  )
}

export { SidebarMenuMain }
export { }
